// 业务类型枚举

/* const businessType = [
  'ADMIN', // 后台系统
  'USER', // 乘客端
  'OA', // 云滴管家
  'DRIVER', // 司机端
  'AGENT', // 代理商
  'OTHER' // 其他零散业务
] */
const getBrowserType = () => {
  const ua = navigator.userAgent.toLocaleLowerCase()
  let browserType = null
  if (ua.match(/msie/) !== null || ua.match(/trident/) !== null) {
    browserType = 'IE'
  } else if (ua.match(/firefox/) !== null) {
    browserType = 'firefox'
  } else if (ua.match(/ucbrowser/) !== null) {
    browserType = 'UCbrowser'
  } else if (ua.match(/opera/) !== null || ua.match(/opr/) !== null) {
    browserType = 'opera'
  } else if (ua.match(/bidubrowser/) !== null) {
    browserType = 'bidubrowser'
  } else if (ua.match(/metasr/) !== null) {
    browserType = 'sougoubrowser'
  } else if (ua.match(/tencenttraveler/) !== null || ua.match(/qqbrowse/) !== null) {
    browserType = 'qqbrowser'
  } else if (ua.match(/maxthon/) !== null) {
    browserType = 'maxthon'
  } else if (ua.match(/chrome/) !== null) {
    browserType = 'chrome'
  } else if (ua.match(/safari/) !== null) {
    browserType = 'Safari'
  } else {
    browserType = 'others'
  }
  return browserType
}
// 获取浏览器名称
const browserName = getBrowserType()
// 获取操作系统名称
const osName = navigator.userAgent.toLowerCase().match(/(mac|windows|linux)/)[1] || 'Unknown'
const platform = {
  osName: osName.toUpperCase(), // 系统环境
  browserName: 'WEB-' + browserName.toUpperCase(), // 宿主环境变量
  businessType: 'ADMIN', // 业务类型
  userAgent: navigator.userAgent
}
export default platform
export { platform }
